/**
 * Canonical breakpoints — match ui-airtable responsive.md / product shell.
 * Primary leaves the drawer at `desktop` (lg / 1024).
 */
export const BP = {
  tablet: 768,
  desktop: 1024,
  wide: 1280,
  ultra: 1536,
} as const;

export type BreakpointName = keyof typeof BP;

export function mediaMin(bp: BreakpointName): string {
  return `(min-width: ${BP[bp]}px)`;
}

export function mediaMaxBelow(bp: BreakpointName): string {
  return `(max-width: ${BP[bp] - 1}px)`;
}
